export default {
    PrivateGuard: {
        pages: [
            {
                name: "PersonalDetails",
                elements: [
                    {
                        type: "dropdown",
                        name: "Board",
                        title: "Name of the 'Security Guards Board' You are Related with",
                        isRequired: true,
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadSecurityBoard",
                            valueName: "SecurityBoardID",
                            titleName: "SecurityBoardName"
                        }
                    },
                    {
                        type: "text",
                        name: "name",
                        title: "Full Name",
                        isRequired: true,
                        validators: [
                            {
                                type: "text",
                                minLength: 0,
                                maxLength: 250
                            }
                        ],
                        size: 12,
                        maxLength: 250
                    },
                    {
                        type: "text",
                        name: "FatherName",
                        validators: [
                            {
                                type: "text",
                                minLength: 0,
                                maxLength: 250
                            }
                        ],
                        size: 12,
                        startWithNewLine: false,
                        title: "Father Name",
                        isRequired: true,
                        maxLength: 250
                    },
		    {
                        type: "text",
                        name: "aadharno",
                        title: "Aadhar No.",
                        isRequired: true,
                        validators: [
                            {
                                type: "text",
                                minLength: 12,
                                maxLength: 12
                            }
                        ],
                        size: 12,
                        maxLength: 12
                    },
                    {
                        type: "comment",
                        name: "Address",
                        title: "Address",
                        isRequired: true,
                        maxLength: 300
                    },
                    {
                        type: "dropdown",
                        name: "State",
                        title: "State",
                        isRequired: true,
                        choices: [
                            "item1",
                            "item2",
                            "item3"
                        ],
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadAllState",
                            valueName: "StateID",
                            titleName: "StateName"
                        }
                    },
                    {
                        type: "dropdown",
                        name: "City",
                        startWithNewLine: false,
                        title: "City",
                        isRequired: true,
                        choices: [
                            "item1",
                            "item2",
                            "item3"
                        ],
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadDistrictByStateID/BB62F7B0-748D-4E64-AD4F-8EF691431FA1",
                            valueName: "DistID",
                            titleName: "DistName"
                        }
                    },
                    {
                        type: "text",
                        name: "PinCode",
                        startWithNewLine: false,
                        title: "Pin Code",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                minValue: 400001,
                                maxValue: 499999
                            }
                        ],
                        inputType: "number",
                        size: 6,
                        maxLength: 6
                    },
                    {
                        type: "text",
                        name: "Designation",
                        title: "Designation",
                        isRequired: true,
                        maxLength: 100
                    },
                    {
                        type: "text",
                        name: "BirthDate",
                        startWithNewLine: false,
                        title: "Date of Birth",
                        isRequired: true,
                        validators: [
                            {
                                type: "expression",
                                expression: "age({BirthDate}) >= 18"
                            }
                        ],
                        inputType: "date",
                        maxLength: 50
                    },
                    {
                        type: "expression",
                        name: "Age",
                        startWithNewLine: false,
                        title: "Age",
                        expression: "age({BirthDate})"
                    },
                    {
                        type: "dropdown",
                        name: "Education",
                        title: "Education",
                        isRequired: true,
                        choices: [
                            "8th Pass",
                            "SSC",
                            "HSC",
                            "Graduate",
                            "Post Graduate"
                        ]
                    },
                    {
                        type: "radiogroup",
                        name: "Gender",
                        startWithNewLine: false,
                        title: "Gender",
                        isRequired: true,
                        choices: [
                            "Male",
                            "Female"
                        ],
                        colCount: 2
                    },
                    {
                        type: "radiogroup",
                        name: "MaritalStatus",
                        startWithNewLine: false,
                        title: "Marital Status",
                        isRequired: true,
                        choices: [
                            "Married",
                            "Unmarried"
                        ],
                        colCount: 2
                    }
                ],
                title: "Personal Details"
            },
            {
                name: "JobDetails",
                elements: [
                    {
                        type: "text",
                        name: "AgencyName",
                        title: "Agency Name",
                        isRequired: true,
                        maxLength: 250
                    },
                    {
                        type: "text",
                        name: "JobDuration",
                        startWithNewLine: false,
                        title: "Job Duration in the Agency ",
                        isRequired: true,
                        inputType: "number",
                        maxLength: 150
                    },
                    {
                        type: "text",
                        name: "PrincipalEmpName",
                        title: "Principal Employer Name",
                        isRequired: true,
                        maxLength: 250
                    },
                    {
                        type: "text",
                        name: "PrincEmpJobDurtn",
                        startWithNewLine: false,
                        title: "Job Duration with Principal Employer",
                        isRequired: true,
                        inputType: "number",
                        maxLength: 2
                    },
                    {
                        type: "text",
                        name: "CurrSal",
                        title: "Current Salary",
                        isRequired: true,
                        inputType: "number",
                        maxLength: 6
                    },
                    // {
                    //     type: "text",
                    //     name: "SalDate",
                    //     startWithNewLine: false,
                    //     title: "Salary Days",
                    //     isRequired: true,
                    //     inputType: "number",
                    //     maxLength: 2
                    // },
                    {
                        type: "text",
                        name: "SalDate",
                        startWithNewLine: false,
                        title: "Salary Payment Date",
                        isRequired: true,
                        inputType: "date",
                        maxLength: 2
                    },
                    {
                        type: "dropdown",
                        name: "SalMode",
                        startWithNewLine: false,
                        title: "Salary Mode",
                        isRequired: true,
                        validators: [
                            {
                                type: "text",
                                minLength: 0,
                                maxLength: 0,
                                allowDigits: true
                            }
                        ],
                        choices: [
                            "Cheque",
                            "Cash",
                            "ECS"
                        ]
                    }
                ],
                title: "Job Details"
            },
            {
                name: "EmploymentBenefits",
                elements: [
                    {
                        type: "dropdown",
                        name: "SalSlip",
                        title: "Is Salary Slip Provided to You?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "BankName",
                        startWithNewLine: false,
                        title: "Name of Bank where Salary is Credited",
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "BankBranch",
                        title: "Bank Branch Name",
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "AccNo",
                        startWithNewLine: false,
                        title: "Bank Account Number",
                        isRequired: true,
                        maxLength: 20
                    },
                    {
                        type: "text",
                        name: "WorkingHours",
                        title: "Daily Working Hours",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                minValue: 1,
                                maxValue: 24
                            }
                        ],
                        inputType: "number"
                    },
                    {
                        type: "dropdown",
                        name: "OTRate",
                        startWithNewLine: false,
                        title: "Overtime Charges",
                        isRequired: true,
                        choices: [
                            "Single Rate",
                            "Double Rate",
                            "No Charges for OT"
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "Weeklyoff",
                        title: "Weekly Off",
                        isRequired: true,
                        choices: [
                            "After Six Working Days",
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "PaidLeave",
                        startWithNewLine: false,
                        title: "Paid Leave",
                        isRequired: true,
                        choices: [
                            "Not Applicable",
                            "Applicable",
                            "Leave Encashment"
                        ]
                    },
                    {
                        type: "text",
                        name: "PaidLeavesNum",
                        visibleIf: "{PaidLeave} <> \"Not Applicable\"",
                        title: "Number of Paid Leaves",
                        isRequired: true,
                        inputType: "number",
                        maxLength: 2
                    },
                    {
                        type: "dropdown",
                        name: "PaidHolidays",
                        startWithNewLine: false,
                        title: "Paid Holidays",
                        isRequired: true,
                        choices: [
                            "Not Applicable",
                            "Applicable",
                            "Leave Encashment"
                        ]
                    },
                    {
                        type: "text",
                        name: "PaidHolidayNum",
                        visibleIf: "{PaidHolidays} <> \"Not Applicable\"",
                        title: "Number of Paid Holidays",
                        isRequired: true,
                        inputType: "number",
                        maxLength: 4
                    },
                    {
                        type: "dropdown",
                        name: "AccidentInsurance",
                        startWithNewLine: false,
                        title: "Do you get compensation for accident",
                        isRequired: true,
                        choices: [
                            "Applicable",
                            "Not Applicable",
                            "ESIC Workman Compensation"
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "LTA",
                        title: "Travel Allowance",
                        isRequired: true,
                        choices: [
                            "Applicable",
                            "Not Applicable"
                        ]
                    },
                    {
                        type: "text",
                        name: "LTAAmount",
                        visibleIf: "{LTA} <> \"Not Applicable\"",
                        startWithNewLine: false,
                        title: "Travel Allow. Amount",
                        isRequired: true,
                        maxLength: 50
                    },
                    {
                        type: "dropdown",
                        name: "HRA",
                        title: "HRA",
                        isRequired: true,
                        choices: [
                            "Applicable",
                            "Not Applicable"
                        ]
                    },
                    {
                        type: "text",
                        name: "HRA Amount",
                        visibleIf: "{HRA} <> \"Not Applicable\"",
                        startWithNewLine: false,
                        isRequired: true,
                        inputType: "number",
                        maxLength: 50
                    }
                ],
                title: "Employment Benefits"
            },
            {
                name: "EmploymentBenefits2",
                elements: [
                    {
                        type: "dropdown",
                        name: "Bonus",
                        title: "Do you Receive Bonus?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "BonusAmt",
                        startWithNewLine: false,
                        title: "Bonus Amount",
                        enableIf: "{Bonus} = \"Yes\"",
                        isRequired: true,
                        inputType: "number"
                    },
                    {
                        type: "dropdown",
                        name: "PF",
                        title: "Is Provident Fund Deducted From Salary?",
                        isRequired: true,
                        choices: [
                            "Deducted",
                            "Not Deducted"
                        ]
                    },
                    {
                        type: "text",
                        name: "PFNo",
                        startWithNewLine: false,
                        title: "PF No",
                        isRequired: true,
                        inputType: "number",
                        maxLength: 50
                    },
                    {
                        type: "dropdown",
                        name: "ESIC",
                        title: "Is ESIC Deducted from Salary",
                        isRequired: true,
                        choices: [
                            "Deducted",
                            "Not Deducted"
                        ]
                    },
                    {
                        type: "text",
                        name: "ESICNo",
                        startWithNewLine: false,
                        title: "ESIC No",
                        isRequired: true,
                        maxLength: 50
                    },
                    {
                        type: "dropdown",
                        name: "MedicalBenifits",
                        title: "Do You Get Medical Benifits?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "AccidentInsu",
                        title: "Are you Covered under Accident Insurance?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "Amt",
                        startWithNewLine: false,
                        title: "Accident Insurance Amount?",
                        enableIf: "{AccidentInsu} = \"Yes\"",
                        isRequired: true,
                        inputType: "number"
                    },
                    {
                        type: "dropdown",
                        name: "Permanant",
                        title: "Are You Permanent?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "AppLetter",
                        startWithNewLine: false,
                        title: "Have You Received Appointment Letter?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    }
                ],
                title: "Employment Benefits -2"
            },
            {
                name: "page5",
                elements: [
                    {
                        type: "dropdown",
                        name: "Uniform",
                        title: "Is Uniform Provided By Agency?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "PayForUniform",
                        startWithNewLine: false,
                        title: "Do You Pay For Uniform?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "SrvcYrsUniform",
                        startWithNewLine: false,
                        title: "No Of Years Of Service To Receive Uniform?",
                        isRequired: true,
                        inputType: "number",
                        maxLength: 40
                    },
                    {
                        type: "dropdown",
                        name: "IsGunHolder",
                        title: "Do You Hold Gun?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "IsGunLicense",
                        startWithNewLine: false,
                        title: "Do You Have Licence For Gun?",
                        enableIf: "{IsGunHolder} = \"Yes\"",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "GunLicenseNo",
                        startWithNewLine: false,
                        title: "License Number of Gun",
                        enableIf: "{IsGunLicense} = \"Yes\"",
                        isRequired: true
                    },
                    {
                        type: "dropdown",
                        name: "Traning",
                        title: "Have You Received Training?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "TraningLocation",
                        startWithNewLine: false,
                        title: "Traning Location",
                        enableIf: "{Traning} = \"Yes\"",
                        isRequired: true,
                        maxLength: 100
                    },
                    {
                        type: "text",
                        name: "UnionName",
                        title: "Union Name",
                        isRequired: true
                    }
                ]
            },
            {
                name: "FileUploads",
                elements: [
                    {
                        type: "file",
                        name: "GuardPhoto",
                        title: "Photo of Guard",
                        isRequired: true,
                        acceptedTypes: "image/*",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "PoliceVerification",
                        title: "Police Verification",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "AadharCard",
                        title: "Aadhar Card",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    }
                ],
                title: "Documents"
            }
        ],
        showPageNumbers: true,
        showProgressBar: "top",
        storeOthersAsComment: false,
        questionTitleTemplate: "{no}. {title} {require}"
    },
    
    PrivateGuardOnBehalf: {
        pages: [
            {
                name: "PersonalDetails",
                elements: [
                    {
                        type: "dropdown",
                        name: "Board",
                        title: "Name of the 'Security Guards Board' You are Related with",
                        isRequired: true,
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadSecurityBoard",
                            valueName: "SecurityBoardID",
                            titleName: "SecurityBoardName"
                        }
                    },
                    {
                        type: "text",
                        name: "name",
                        title: "Full Name",
                        isRequired: true,
                        validators: [
                            {
                                type: "text",
                                minLength: 0,
                                maxLength: 250
                            }
                        ],
                        size: 12,
                        maxLength: 250
                    },
                    {
                        type: "text",
                        name: "FatherName",
                        startWithNewLine: false,
                        title: "Father Name",
                        validators: [
                            {
                                type: "text",
                                minLength: 0,
                                maxLength: 250
                            }
                        ],
                        size: 12,
                        // isRequired: false,
                        maxLength: 250
                    },
                    {
                        type: "comment",
                        name: "Address",
                        title: "Address",
                        isRequired: true,
                        maxLength: 300
                    },
                    {
                        type: "dropdown",
                        name: "State",
                        title: "State",
                        isRequired: true,
                        choices: [
                            "item1",
                            "item2",
                            "item3"
                        ],
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadAllState",
                            valueName: "StateID",
                            titleName: "StateName"
                        }
                    },
                    {
                        type: "dropdown",
                        name: "City",
                        startWithNewLine: false,
                        title: "City",
                        isRequired: true,
                        choices: [
                            "item1",
                            "item2",
                            "item3"
                        ],
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadDistrictByStateID/BB62F7B0-748D-4E64-AD4F-8EF691431FA1",
                            valueName: "DistID",
                            titleName: "DistName"
                        }
                    },
                    {
                        type: "text",
                        name: "PinCode",
                        startWithNewLine: false,
                        title: "Pin Code",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                minValue: 400001,
                                maxValue: 499999
                            }
                        ],
                        inputType: "number",
                        size: 6,
                        maxLength: 6
                    },
                    {
                        type: "text",
                        name: "Designation",
                        title: "Designation",
                        isRequired: true,
                        maxLength: 100
                    },
                    {
                        type: "text",
                        name: "BirthDate",
                        startWithNewLine: false,
                        title: "Date of Birth",
                        isRequired: true,
                        validators: [
                            {
                                type: "expression",
                                expression: "age({BirthDate}) >= 18"
                            }
                        ],
                        inputType: "date",
                        maxLength: 50
                    },
                    {
                        type: "expression",
                        name: "Age",
                        startWithNewLine: false,
                        title: "Age",
                        expression: "age({BirthDate})"
                    },
                    {
                        type: "dropdown",
                        name: "Education",
                        title: "Education",
                        isRequired: true,
                        choices: [
                            "8th Pass",
                            "SSC",
                            "HSC",
                            "Graduate",
                            "Post Graduate"
                        ]
                    },
                    {
                        type: "radiogroup",
                        name: "Gender",
                        startWithNewLine: false,
                        title: "Gender",
                        isRequired: true,
                        choices: [
                            "Male",
                            "Female"
                        ],
                        colCount: 2
                    },
                    {
                        type: "radiogroup",
                        name: "MaritalStatus",
                        startWithNewLine: false,
                        title: "Marital Status",
                        isRequired: true,
                        choices: [
                            "Married",
                            "Unmarried"
                        ],
                        colCount: 2
                    }
                ],
                title: "Personal Details"
            }            
        ],
        showPageNumbers: true,
        showProgressBar: "top",
        storeOthersAsComment: false,
        questionTitleTemplate: "{no}. {title} {require}"
    },


    Agency: {
        questionTitleTemplate: "{no}. {title} {require}",

        pages: [
            {
                name: "AgencyDetails",
                elements: [
                    {
                        type: "dropdown",
                        name: "Board",
                        title: "Name of the 'Security Guards Board' You are Related with",
                        isRequired: true,
                        choices: [],
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadSecurityBoard",
                            valueName: "SecurityBoardID",
                            titleName: "SecurityBoardName"
                        }
                    },
                    {
                        type: "text",
                        name: "AgencyName",
                        title: "Name of the Employer Agency",
                        isRequired: true,
                        requiredErrorText: "Enter Name of the Agency",
                        maxLength: 250,
                        placeHolder: "Agency Name"
                    },
                    {
                        type: "comment",
                        name: "AgencyAddress",
                        title: "Address of the Agency",
                        isRequired: true,
                        maxLength: 400
                    },
                    {
                        type: "dropdown",
                        name: "City",
                        title: "City",
                        isRequired: true,
                        choices: ["item1", "item2", "item3"],
                        choicesByUrl: {
                            url:
                                "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadDistrictByStateID/BB62F7B0-748D-4E64-AD4F-8EF691431FA1",
                            valueName: "DistID",
                            titleName: "DistName"
                        }
                    },
                    {
                        type: "text",
                        name: "PinCode",
                        startWithNewLine: false,
                        title: "Pin Code",
                        isRequired: true,
                        validators: [{ type: "numeric", minValue: 400001, maxValue: 499999 }],
                        inputType: "number",
                        size: 6,
                        maxLength: 6
                    },
                    {
                        type: "text",
                        name: "ContactNumber",
                        title: "Contact  Number",
                        isRequired: true,
                        inputType: "tel",
                        placeHolder: "Enter Contact Number of the Agency"
                    },
                    {
                        type: "text",
                        name: "EmailID",
                        title: "Email ID",
                        startWithNewLine: false,
                        isRequired: true,
                        validators: [{ type: "email" }],
                        inputType: "email",
                        placeHolder: "Email of Agency"
                    },
                    {
                        type: "dropdown",
                        name: "CompanyType",
                        title: "Whether the Employer Agency is",
                        isRequired: true,
                        choices: [
                            "Proprietary Firm",
                            "Partnership Firm",
                            "Private Limited Co.",
                            "Public Limited Co.",
                            "Co-op Society",
                            "Govt. or Semi Govt."
                        ]
                    },
                  
                ],
                title: "Agency Details"
            },
            {
                name: "Owners",
                elements: [
                    {
                        type: "paneldynamic",
                        name: "OwnerDetails",
                        title: "Owner/Partner/Director Detais",
                        isRequired: true,
                        templateElements: [
                            {
                                type: "text",
                                name: "OwnerName",
                               
                               
                                title: "Name",
                                isRequired: true
                            },
                            {
                                type: "comment",
                                name: "OwnerAddress",
                                
                                title: "Address",
                                isRequired: true
                            },
                            {
                                type: "text",
                                name: "OwnerMobile",
                               
                                title: "Mobile Number",
                                isRequired: true
                            },
                            {
                                type: "text",
                                name: "OwnerEmail",
                                
                                startWithNewLine: false,
                                title: "Email ID",
                                isRequired: true,
                                validators: [{ type: "email" }],
                                inputType: "email"
                            }
                        ]
                    }
                ],
                title: "Owner Details"
            },
            {
                name: "LicenseDetails",
                elements: [
                    {
                        type: "text",
                        name: "EstablishmentYear",
                        title: "Year of Establishment",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                text: "Year Should be in Proper Format",
                                minValue: 1950,
                                maxValue: 2100
                            }
                        ],
                        inputType: "number"
                    },
                    {
                        type: "text",
                        name: "ShopActRegNum",
                        title:
                            "Registration Number as Per Bombay Shop & Commercial Establishment Act",
                        isRequired: true,
                        placeHolder: "Shop Act Registration Number"
                    },
                    {
                        type: "text",
                        name: "MaleEmployeeCount",
                        title: "Number of Male Employees",
                        isRequired: true,
                        validators: [{ type: "numeric", minValue: 0, maxValue: 10000 }],
                        inputType: "number"
                    },
                    {
                        type: "text",
                        name: "FemaleEmployeeCount",
                        startWithNewLine: false,
                        title: "Number of Female Employees",
                        isRequired: true,
                        validators: [{ type: "numeric", minValue: 0, maxValue: 10000 }],
                        inputType: "number"
                    },
                    {
                        type: "text",
                        name: "PSRA",
                        title: "PSRA License Number",
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "PsraLicenseDate",
                        title: "License Date",
                        isRequired: true,
                        inputType: "date"
                    },
                    {
                        type: "text",
                        name: "PsaraDueDate",
                        startWithNewLine: false,
                        title: "License Validity Date",
                        isRequired: true,
                        inputType: "date"
                    },
                    { type: "text", name: "PAN", title: "PAN", isRequired: true },
                    {
                        type: "text",
                        name: "GST",
                        startWithNewLine: false,
                        title: "GST No",
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "PTNum",
                        title: "Professional Tax Reg No",
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "EmployeeWelfare",
                        startWithNewLine: false,
                        title: "Employee Welfare Board Reg No",
                        isRequired: true
                    }
                ],
                title: "License Details"
            },
            {
                name: "GuardDetails",
                elements: [
                    {
                        type: "multipletext",
                        name: "SecurityGuardNonWeapon",
                        title: "Security Guards (Unarmed)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowance", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SecurityGuardsWeapon",
                        title: "Security Guards (Armed Guard)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "HeadSGNW",
                        title: "Head Security Guards (Unarmed)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "HeadSGW",
                        title: "Head Security Guards (Armed Guard)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SSNW",
                        title: "Security Supervisor (Unarmed)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SSW",
                        title: "Security Supervisor (Armed Guard)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "ASONW",
                        title: "Asst. Security Officer (Unarmed)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "ASOW",
                        title: "Asst. Security Officer (Armed Guard)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SQNW",
                        title: "Security Officer (Unarmed)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SOW",
                        title: "Security Officer (Armed Guard)",
                        isRequired: true,
                        items: [
                            {
                                name: "XSvcMan",
                                inputType: "number",
                                title: "Ex-Serviceman",
                                maxLength: "",
                                validators: [{ type: "numeric", minValue: 0, maxValue: 100000 }]
                            },
                            { name: "Domiciled", title: "Maharashtra Domiciled" },
                            { name: "KasmirCtzn", title: "Citizens of Kashmir" },
                            { name: "OtherCtzn", title: "Citizens of Other State" },
                            { name: "Basic", title: "Basic" },
                            { name: "DA", title: "D.A." },
                            { name: "Allowances", title: "Allowances" },
                            { name: "Total", title: "Total Salary" }
                        ],
                        colCount: 3
                    }
                ],
                title: "Guard Details"
            },
            {
                name: "EmployerDetails",
                elements: [
                    {
                        type: "matrixdynamic",
                        name: "PrincipalEmployers",
                        title: "Details of Principal Employer",
                        isRequired: true,
                        columns: [
                            {
                                name: "EmployerRegistrationNum",
                                title: "Registration Num",
                                isRequired: true
                            },
                            {
                                name: "EmployerName",
                                title: "Name",
                                isRequired: true
                            },
                            {
                                name: "GuardsEmployed",
                                title: "Guards Employed",
                                isRequired: true
                            },
                            {
                                name: "EmployementPeriod",
                                title: "Employment Period ",
                                isRequired: true
                            }
                        ],
                        cellType: "text",
                        rowCount: 1
                    },
                    
                    {
                        type: "text",
                        name: "totalno",
                        title: "Total No Of Court Cases",
                        isRequired: true,
                        inputType: "Number",
                        placeHolder: "Enter total no of court cases"
                    },
                    {
                        type: "text",
                        name: "discription",
                        title: " Cases Discription",
                        startWithNewLine: false,
                        isRequired: true,
                        // validators: [{ type: "email" }],
                        inputType: "test",
                        placeHolder: "Discriptions"
                    },
                    {
                        type: "text",
                        name: "contactperson",
                        title: "Contact Person",
                        isRequired: true,
                        inputType: "text",
                        placeHolder: "Contact Person"
                    },
                   
                    {
                        type: "text",
                        name: "mobileno",
                        title: "Mobile Number",
                        isRequired: true,
                        inputType: "text",
                        validators: [
                            {
                                type: "numeric",
                                minValue: 0,
                                maxValue: 9999999999
                            }
                        ],
                        size: 10
                    },
                    {
                        type: "text",
                        name: "employergstno",
                        startWithNewLine: false,
                        title: " Employer GST No",
                        isRequired: true
                    },
                ],
                title: "Principal Employer Details"
            },
            
            {
                name: "EmployentConditions",
                elements: [
                    {
                        type: "text",
                        name: "WorkingHours",
                        title: "Daily Working Hours",
                        isRequired: true,
                        validators: [{ type: "numeric", minValue: 1, maxValue: 24 }],
                        inputType: "number"
                    },
                    {
                        type: "dropdown",
                        name: "OTRate",
                        startWithNewLine: false,
                        title: "Overtime Charges",
                        isRequired: true,
                        choices: ["Single Rate", "Double Rate", "No Charges for OT"]
                    },
                    {
                        type: "dropdown",
                        name: "Weeklyoff",
                        title: "Weekly Off",
                        isRequired: true,
                        choices: [
                            "After Six Working Days",
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "PaidLeave",
                        startWithNewLine: false,
                        title: "Paid Leave",
                        isRequired: true,
                        choices: ["Not Applicable", "Applicable", "Leave Encashment"]
                    },
                    {
                        type: "text",
                        name: "PaidLeavesNum",
                        visibleIf: '{PaidHolidays} <> "Not Applicable"',
                        title: "Number of Paid Leaves",
                        isRequired: true,
                        inputType: "number"
                    },
                    {
                        type: "dropdown",
                        name: "PaidHolidays",
                        startWithNewLine: false,
                        title: "Paid Holidays",
                        isRequired: true,
                        choices: ["Not Applicable", "Applicable", "Leave Encashment"]
                    },
                    {
                        type: "text",
                        name: "PaidHolidayNum",
                        visibleIf: '{PaidLeave} <> "Not Applicable"',
                        title: "Number of Paid Holidays",
                        isRequired: true,
                        inputType: "number"
                    },
                    {
                        type: "dropdown",
                        name: "AccidentInsurance",
                        startWithNewLine: false,
                        title: "Accidental Insurance",
                        isRequired: true,
                        choices: ["Applicable", "Not Applicable", "ESIC Workman Compensation"]
                    },
                    {
                        type: "dropdown",
                        name: "LTA",
                        title: "LTA",
                        isRequired: true,
                        choices: ["Applicable", "Not Applicable"]
                    },
                    {
                        type: "text",
                        name: "LTAAmount",
                        visibleIf: '{LTA} <> "Not Applicable"',
                        startWithNewLine: false,
                        title: "LTA Amount",
                        isRequired: true
                    },
                    {
                        type: "dropdown",
                        name: "HRA",
                        title: "HRA",
                        isRequired: true,
                        choices: ["Applicable", "Not Applicable"]
                    },
                    {
                        type: "text",
                        name: "HRAAmount",
                        title: "HRA Amount",
                        visibleIf: '{HRA} <> "Not Applicable"',
                        startWithNewLine: false,
                        isRequired: true,
                        inputType: "number"
                    },
                    {
                        type: "text",
                        name: "Bonus",
                        title: "Bonus%",
                        isRequired: true,
                        validators: [{ type: "numeric", minValue: 1, maxValue: 100 }],
                        inputType: "number"
                    },
                    {
                        type: "dropdown",
                        name: "BonusDistribution",
                        visibleIf: "{Bonus} > 0",
                        startWithNewLine: false,
                        title: "Bonus Distribution",
                        isRequired: true,
                        choices: ["Diwali", "At the Start of Financial Year"]
                    },
                    {
                        type: "dropdown",
                        name: "MedicalFacilities",
                        title: "Medical Facilities",
                        isRequired: true,
                        choices: ["Through ESIC", "Through Hospital"]
                    },
                    {
                        type: "dropdown",
                        name: "EPF",
                        startWithNewLine: false,
                        title: "Provident Fund",
                        isRequired: true,
                        choices: ["Applicable", "Not Applicable"]
                    },
                    {
                        type: "text",
                        name: "EPFRegNum",
                        visibleIf: '{EPF} <> "Not Applicable"',
                        title: "PF Registration Number",
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "GratuityYears",
                        startWithNewLine: false,
                        title: "Service Years for Gratuity",
                        isRequired: true,
                        validators: [{ type: "numeric", minValue: 0, maxValue: 30 }],
                        inputType: "number"
                    },
                    {
                        type: "text",
                        name: "LICGratuityNo",
                        title: "LIC Group Gratuity Scheme Number"
                    },
                    {
                        type: "dropdown",
                        name: "Uniform",
                        title: "Uniform Given to Guard",
                        isRequired: true,
                        choices: [
                            "Start of Service",
                            "After One Year of Service",
                            "Start of Service after Deduction of Money"
                        ]
                    },
                    {
                        type: "text",
                        name: "ESIC",
                        title: "ESIC Registration No",
                        isRequired: true
                    },
                    {
                        type: "comment",
                        name: "SocialBenefits",
                        title: "Social /Other Benefits",
                        isRequired: true
                    },
                    {
                        type: "boolean",
                        name: "MaternityLeave",
                        title: "Maternity Leave Provided to Lady Guards",
                        isRequired: true
                    },
                    {
                        type: "dropdown",
                        name: "SalryPayer",
                        title: "Salry Paid By",
                        isRequired: true,
                        choices: ["Principal Employer", "Agency"]
                    },
                    {
                        type: "dropdown",
                        name: "SalaryMode",
                        startWithNewLine: false,
                        title: "Salary Mode",
                        isRequired: true,
                        choices: ["Cash", "Cheque", "NEFT"]
                    },
                    {
                        type: "text",
                        name: "SalaryDay",
                        title: "Salary Payment Day",
                        isRequired: true,
                        validators: [{ type: "numeric", minValue: 1, maxValue: 31 }],
                        inputType: "number"
                    },
                    {
                        type: "boolean",
                        name: "Training",
                        startWithNewLine: false,
                        title: "Training Provided to Guards",
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "TrainerName",
                        visibleIf: "{Training} = true",
                        title: "Name of Training Provider"
                    },
                    {
                        type: "text",
                        name: "TrainingDays",
                        title: "Training Days",
                        visibleIf: "{Training}= True",
                        startWithNewLine: false,
                        isRequired: true,
                        inputType: "number"
                    },
                    {
                        type: "text",
                        name: "UnionName",
                        title: "Union of Which Your Employees are Member",
                        isRequired: true
                    },
                    {
                        type: "boolean",
                        name: "PoliceVerification",
                        startWithNewLine: false,
                        title: "Police Verification of Guards is Done",
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "ReasonNonVerification",
                        visibleIf: "{PoliceVerification} = false",
                        title: "Reason for Non Police Verification",
                        isRequired: true
                    }
                ],
                title: "Employment Hours, Leaves and Amenities Details"
            },
            {
                name: "BankDetails",
                elements: [
                    {
                        type: "paneldynamic",
                        name: "BankDetails1",
                        title: "Bank Account Details of the Agency",
                        isRequired: true,
                        templateElements: [
                            {
                                type: "text",
                                name: "BankName",
                                title: "Bank Name",
                                isRequired: true
                            },
                            {
                                type: "text",
                                name: "BranchName",
                                startWithNewLine: false,
                                title: "Branch Name"
                            },
                            {
                                type: "text",
                                name: "BankAccountNumber",
                                title: "Bank Account Number",
                                isRequired: true
                            }
                        ]
                    }
                ],
                title: "Bank Details"
            },
            {
                name: "FileUploads",
                elements: [
                    {
                        type: "file",
                        name: "OwnerPoliceVerification",
                        title: "Owner Police Verification",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    
                    {
                        type: "file",
                        name: "PSARALicenseCopy",
                        title: "PSARA License",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "BalanceSheets",
                        title: "Affidavit (On Stamp Paper Of Rs.300)",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    
                    {
                        type: "file",
                        name: "PTRegistration",
                        visibleIf: "{PTNum} notempty",
                        title: "PT Chalan Copy",
                        acceptedTypes: "image/*, application/pdf",
                        isRequired: true,
                        storeDataAsText: false,
                        imageWidth: "40",
                        maxSize: 0
                    },
                    // {
                    //     type: "file",
                    //     name: "GSTReturns",
                    //     visibleIf: "{GST} notempty",
                    //     title: "GST Returns of Last 3 years",
                    //     acceptedTypes: "image/*, application/pdf",
                    //     isRequired: true,
                    //     storeDataAsText: false,
                    //     imageWidth: "40",
                    //     maxSize: 0
                    // },
                    {
                        type: "file",
                        name: "PFRegistration",
                        visibleIf: '{EPF} = "Applicable"',
                        title: "Provident Fund chalan copy",
                        acceptedTypes: "image/*, application/pdf",
                        isRequired: true,
                        storeDataAsText: false,
                        imageWidth: "40",
                        maxSize: 0
                        
                    },
                    {
                        type: "file",
                        name: "ESICRegistration",
                        visibleIf: "{ESIC} notempty",
                        title: "ESIC chalan copy",
                        acceptedTypes: "image/*, application/pdf",
                        isRequired: true,
                        storeDataAsText: false,
                        imageWidth: "40",
                        maxSize: 0
                    },
                    // {
                    //     type: "file",
                    //     name: "Aggrement",
                    //     title: "Aggrement",
                    //     acceptedTypes: "image/*, application/pdf",
                    //     isRequired: true,
                    //     storeDataAsText: false,
                    //     imageWidth: "40",
                    //     maxSize: 0
                    // },
                    // {
                    //     type: "file",
                    //     name: "ConsentLetter",
                    //     title: "Consent Letter",
                    //     isRequired: true,
                    //     acceptedTypes: "image/*, application/pdf",
                    //     imageWidth: "40",
                    //     storeDataAsText: false,
                    //     maxSize: 0
                    // },
                    // {
                    //     type: "file",
                    //     name: "Declaration",
                    //     title: "Declaration",
                    //     acceptedTypes: "image/*, application/pdf",
                    //     isRequired: true,
                    //     storeDataAsText: false,
                    //     imageWidth: "40",
                    //     maxSize: 0
                    // },
                    {
                        type: "file",
                        name: "PANCard",
                        title: "PAN Card",
                        acceptedTypes: "image/*, application/pdf",
                        isRequired: true,
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "EmpWelfareRegistration",
                        visibleIf: "{EmployeeWelfare} notempty",
                        title: "Employee Welfare Board Registration",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },  
                    {
                        type: "file",
                        name: "CompanyIncorporation",
                        title: "Company Incorporation",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "BankAccountProof",
                        title:
                            // "Bank Account Proof (Cheque Book/Account Statement with Account and Name Details/Passbook)",
                            "Three months DBT information of security guards (Wage register, Paylip)",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    // {
                    //     type: "file",
                    //     name: "OwnerPoliceVerification",
                    //     title:
                    //         "Owner Police Verification Certificate",
                    //     isRequired: true,
                    //     acceptedTypes: "image/*, application/pdf",
                    //     imageWidth: "40",
                    //     storeDataAsText: false,
                    //     maxSize: 0
                    // },
                    {
                        type: "file",
                        name: "Agreement",
                        title:
                            "Agreement with Employer",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "Declaration",
                        title:
                            "Declaration By Employer Agency on Stamp Paper",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "DBT",
                        title:
                            // "Bank account statement (DBT Scroll)",
                            "DBT Bank Scroll (3 month Guards passbook Xerox)",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    }
                ],
                title: "Documents"
            }
        ],
        showPageNumbers: true,
        showProgressBar: "top",
        storeOthersAsComment: false,
        firstPageIsStarted: false
    },
    Employer: {
        pages: [
            {
                name: "Establishment",
                elements: [
                    {
                        type: "dropdown",
                        name: "Board",
                        title: "Name of the 'Security Guards Board' You are Related with",
                        isRequired: true,
                        choicesByUrl: {
                            //url: "https://api.sgbregistration.in/api/Masters/ReadSecurityBoard",
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadSecurityBoard",
                            valueName: "SecurityBoardID",
                            titleName: "SecurityBoardName"
                        }
                    },
                    {
                        type: "text",
                        name: "EmployerName",
                        title: "Establishment Name",
                        isRequired: true,
                        validators: [
                            {
                                type: "text",
                                minLength: 0
                            }
                        ]
                    },
                    {
                        type: "comment",
                        name: "EmployerAddress",
                        title: "Establishment Address",
                        isRequired: true
                    },
                    {
                        type: "dropdown",
                        name: "City",
                        title: "City",
                        isRequired: true,
                        choices: [
                            "item1",
                            "item2",
                            "item3"
                        ],
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadDistrictByStateID/BB62F7B0-748D-4E64-AD4F-8EF691431FA1",
                            valueName: "DistID",
                            titleName: "DistName"
                        }
                    },
                    {
                        type: "text",
                        name: "Pincode",
                        startWithNewLine: false,
                        title: "Pin Code",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                minValue: 0,
                                maxValue: 5000000
                            }
                        ],
                        inputType: "number"
                    },
                    {
                        type: "text",
                        name: "TelNo",
                        title: "Telephone Number",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                minValue: 0,
                                maxValue: 99999999999
                            }
                        ],
                        inputType: "number",
                        size: 50
                    },
                    {
                        type: "text",
                        name: "EmailId",
                        startWithNewLine: false,
                        title: "E-mail ID",
                        isRequired: true,
                        validators: [
                            {
                                type: "email"
                            }
                        ],
                        inputType: "email"
                    },
                    {
                        type: "dropdown",
                        name: "BusinessType",
                        title: "Types of Business",
                        isRequired: true,
                        hasOther: true,
                        choices: [
                            "Shop",
                            "Office",
                            "Factory",
                            "Housing Development Corporation"
                        ]
                    },
                    {
                        type: "text",
                        name: "FactoryType",
                        startWithNewLine: false,
                        title: "Factory Type",
                        enableIf: "{BusinessType} = \"Factory\"",
                        isRequired: true,
                        validators: [
                            {
                                type: "text",
                                minLength: 0,
                                maxLength: 0,
                                allowDigits: true
                            }
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "WhetherTheEstablishmentIs",
                        title: "Whether The Establishment Is",
                        isRequired: true,
                        hasOther: true,
                        choices: [
                            "Private Firm",
                            "Partnership Firm",
                            "Pvt.Ltd.Co.",
                            "Public Ltd.Co.Society",
                            "Govt. or Semi.Govt."
                        ]
                    },
                    {
                        type: "text",
                        name: "IncorporationDate",
                        startWithNewLine: false,
                        title: "Date of Incorporation",
                        isRequired: true,
                        inputType: "date"
                    },
                    {
                        type: "text",
                        name: "RegistrationNo",
                        title: "Registration No",
                        isRequired: true,
                        inputType: "text"
                    },
                    {
                        type: "text",
                        name: "RegistrationDate",
                        startWithNewLine: false,
                        title: "Registration Date",
                        isRequired: true,
                        inputType: "date"
                    }
                ],
                title: "Establishment Details"
            },
            {
                name: "Owners",
                elements: [
                    {
                        type: "paneldynamic",
                        name: "OwnerDetails",
                        title: "Owner/Partner/Director Detais",
                        templateElements: [
                            {
                                type: "text",
                                name: "OwnerName",
                                
                                title: "Name",
                                isRequired: true,
                                validators: [
                                    {
                                        type: "text",
                                        minLength: 0,
                                        maxLength: 0,
                                        allowDigits: true
                                    }
                                ]
                            },
                            {
                                type: "comment",
                                name: "OwnerAddress",
                                title: "Address",
                                isRequired: true
                            },
                            {
                                type: "text",
                                name: "OwnerMobile",
                                title: "Mobile Number",
                                isRequired: true,
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 9999999999
                                    }
                                ],
                                size: 10
                            },
                            {
                                type: "text",
                                name: "OwnerEmail",
                                startWithNewLine: false,
                                title: "Email ID",
                                isRequired: true,
                                validators: [
                                    {
                                        type: "email"
                                    }
                                ],
                                inputType: "email"
                            }
                        ]
                    }
                ],
                title: "Owner Details"
            },
            {
                name: "GuardDetails",
                elements: [
                    {
                        type: "multipletext",
                        name: "SecurityGuards",
                        title: "Security Guards",
                        isRequired: true,
                        items: [
                            {
                                name: "TotalMaleGuards",
                                title: "Total Male Guards",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "TotalFemaleGuards",
                                title: "Total Female Guards",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "BasicSalary",
                                title: "Basic Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 5000000
                                    }
                                ]
                            },
                            {
                                name: "DA",
                                title: "DA",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "OtherAllowance",
                                title: "Other Allowance",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "TotalSalary",
                                title: "Total Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SecuritySupervisor",
                        title: "Security Supervisor",
                        isRequired: true,
                        items: [
                            {
                                name: "TotalMaleSupervisor",
                                title: "Total Male Supervisor",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "TotalFemaleSupervisor",
                                title: "Total Female Supervisor",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "BasicSalary",
                                title: "Basic Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "DA",
                                title: "DA",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "OtherAllowance",
                                title: "Other Allowance",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "TotalSalary",
                                title: "Total Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SecurityOfficer",
                        title: "Security Officer",
                        isRequired: true,
                        items: [
                            {
                                name: "TotalMaleOfficer",
                                title: "Total Male Officer",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "TotalFemaleOfficer",
                                title: "Total Female Officer",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 50
                                    }
                                ]
                            },
                            {
                                name: "BasicSalary",
                                title: "Basic Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "DA",
                                title: "DA",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "OtherAllowance",
                                title: "Other Allowance"
                            },
                            {
                                name: "TotalSalary",
                                title: "Total Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "HeadSecurityOfficer",
                        title: "Head Security Officer",
                        isRequired: true,
                        items: [
                            {
                                name: "TotalMaleHeadOfficer",
                                title: "Total Male Head Officer",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "TotalFemaleHeadOfficer",
                                title: "Total Female Head Officer",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "BasicSalary",
                                title: "Basic Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "DA",
                                title: "DA",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "OtherAllowance",
                                title: "Other Allowance",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "TotalSalary",
                                title: "Total Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            }
                        ],
                        colCount: 3
                    }
                ],
                title: "Guard Details"
            },
            {
                name: "Recruitment",
                elements: [
                    {
                        type: "dropdown",
                        name: "Transfer",
                        title: "Do You Transfer Guards?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "Reason",
                        visibleIf: "{Transfer}=\"Yes\"",
                        startWithNewLine: false,
                        title: "Reason",
                        isRequired: true
                    },
                    {
                        type: "dropdown",
                        name: "PoliceVerification",
                        title: "Have You completed Police Verification of Guards?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "NonVerificationReason",
                        visibleIf: "{PoliceVerification}=\"No\"",
                        startWithNewLine: false,
                        title: "Reason for No Police Verification",
                        isRequired: true
                    },
                  
                ],
                title: "Recruitment Details"
            },
            {
                name: "Documents",
                elements: [
                    {
                        type: "file",
                        name: "AgreementCopy",
                        title: "Agreement Copy with Principal Agency",
                        isRequired: true,
                        storeDataAsText: false,
                        acceptedTypes: "image/*, application/pdf",
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "PAN",
                        title: "PAN Card",
                        isRequired: true,
                        storeDataAsText: false,
                        acceptedTypes: "image/*, application/pdf",
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "GSTRegistration",
                        title: "GST Registration Certificate",
                        isRequired: true,
                        storeDataAsText: false,
                        acceptedTypes: "image/*, application/pdf",
                        maxSize: 0
                    }
                ],
                title: "Documents"
            }
        ],
        showPageNumbers: true,
        showProgressBar: "top",
        storeOthersAsComment: false,
        questionTitleTemplate: "{no}. {title} {require}"
    },
    SgbEmployer: {
        pages: [
            {
                name: "Establishment",
                elements: [
                    {
                        type: "dropdown",
                        name: "Board",
                        title: "Name of the 'Security Guards Board' You are Related with ",
                        isRequired: true,
                        choicesByUrl: {
                            //url: "https://api.sgbregistration.in/api/Masters/ReadSecurityBoard",
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadSecurityBoard",
                            valueName: "SecurityBoardID",
                            titleName: "SecurityBoardName"
                        }
                    },
                    {
                        type: "text",
                        name: "EmployerName",
                        title: "Establishment Name (Name As Per shops & establishment Document)",
                        isRequired: true,
                        validators: [
                            {
                                type: "text",
                                minLength: 0
                            }
                        ]
                    },
                    {
                        type: "comment",
                        name: "EmployerAddress",
                        title: "Establishment Address",
                        isRequired: true
                    },
                    {
                        type: "dropdown",
                        name: "City",
                        title: "City",
                        isRequired: true,
                        choices: [
                            "item1",
                            "item2",
                            "item3"
                        ],
                        choicesByUrl: {
                            url: "https://9lmwzmqfa6.execute-api.ap-south-1.amazonaws.com/Prod/api/Masters/ReadDistrictByStateID/BB62F7B0-748D-4E64-AD4F-8EF691431FA1",
                            valueName: "DistID",
                            titleName: "DistName"
                        }
                    },
                    {
                        type: "text",
                        name: "Pincode",
                        startWithNewLine: false,
                        title: "Pin Code",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                minValue: 0,
                                maxValue: 5000000
                            }
                        ],
                        inputType: "number"
                    },
                    {
                        type: "text",
                        name: "TelNo",
                        title: "Telephone Number",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                minValue: 0,
                                maxValue: 99999999999
                            }
                        ],
                        inputType: "number",
                        size: 50
                    },
                    {
                        type: "text",
                        name: "EmailId",
                        startWithNewLine: false,
                        title: "E-mail ID",
                        isRequired: true,
                        validators: [
                            {
                                type: "email"
                            }
                        ],
                        inputType: "email"
                    },
                    {
                        type: "dropdown",
                        name: "BusinessType",
                        title: "Types of Business",
                        isRequired: true,
                        hasOther: true,
                        choices: [
                            "Shop",
                            "Office",
                            "Factory",
                            "Housing Development Corporation"
                        ]
                    },
                    {
                        type: "text",
                        name: "FactoryType",
                        startWithNewLine: false,
                        title: "Factory Type",
                        enableIf: "{BusinessType} = \"Factory\"",
                        isRequired: true,
                        validators: [
                            {
                                type: "text",
                                minLength: 0,
                                maxLength: 0,
                                allowDigits: true
                            }
                        ]
                    },
                    {
                        type: "dropdown",
                        name: "WhetherTheEstablishmentIs",
                        title: "Whether The Establishment Is",
                        isRequired: true,
                        hasOther: true,
                        choices: [
                            "Private Firm",
                            "Partnership Firm",
                            "Pvt.Ltd.Co.",
                            "Public Ltd.Co.Society",
                            "Govt. or Semi.Govt."
                        ]
                    },
                    {
                        type: "text",
                        name: "IncorporationDate",
                        startWithNewLine: false,
                        title: "Date of Incorporation",
                        isRequired: true,
                        inputType: "date"
                    },
                    {
                        type: "text",
                        name: "RegistrationNo",
                        title: "Registration No",
                        isRequired: true,
                        inputType: "text"
                    },
                    {
                        type: "text",
                        name: "RegistrationDate",
                        startWithNewLine: false,
                        title: "Registration Date",
                        isRequired: true,
                        inputType: "date"
                    }
                ],
                title: "Establishment Details"
            },
            {
                name: "Owners",
                elements: [
                    {
                        type: "paneldynamic",
                        name: "OwnerDetails",
                        title: "Owner/Partner/Director Detais",
                        templateElements: [
                            {
                                type: "text",
                                name: "OwnerName",
                                
                                title: "Name",
                                isRequired: true,
                                validators: [
                                    {
                                        type: "text",
                                        minLength: 0,
                                        maxLength: 0,
                                        allowDigits: true
                                    }
                                ]
                            },
                            {
                                type: "comment",
                                name: "OwnerAddress",
                                title: "Address",
                                isRequired: true
                            },
                            {
                                type: "text",
                                name: "OwnerMobile",
                                title: "Mobile Number",
                                isRequired: true,
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 9999999999
                                    }
                                ],
                                size: 10
                            },
                            {
                                type: "text",
                                name: "OwnerEmail",
                                startWithNewLine: false,
                                title: "Email ID",
                                isRequired: true,
                                validators: [
                                    {
                                        type: "email"
                                    }
                                ],
                                inputType: "email"
                            }
                        ]
                    }
                ],
                title: "Owner Details"
            },
            {
                name: "GuardDetails",
                elements: [
                    {
                        type: "multipletext",
                        name: "SecurityGuards",
                        title: "Security Guards",
                        isRequired: true,
                        items: [
                            {
                                name: "TotalMaleGuards",
                                title: "Total Male Guards",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "TotalFemaleGuards",
                                title: "Total Female Guards",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "BasicSalary",
                                title: "Basic Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 5000000
                                    }
                                ]
                            },
                            {
                                name: "DA",
                                title: "DA",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "OtherAllowance",
                                title: "Other Allowance",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "TotalSalary",
                                title: "Total Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SecuritySupervisor",
                        title: "Security Supervisor",
                        isRequired: true,
                        items: [
                            {
                                name: "TotalMaleSupervisor",
                                title: "Total Male Supervisor",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "TotalFemaleSupervisor",
                                title: "Total Female Supervisor",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "BasicSalary",
                                title: "Basic Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "DA",
                                title: "DA",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "OtherAllowance",
                                title: "Other Allowance",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "TotalSalary",
                                title: "Total Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "SecurityOfficer",
                        title: "Security Officer",
                        isRequired: true,
                        items: [
                            {
                                name: "TotalMaleOfficer",
                                title: "Total Male Officer",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "TotalFemaleOfficer",
                                title: "Total Female Officer",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 50
                                    }
                                ]
                            },
                            {
                                name: "BasicSalary",
                                title: "Basic Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "DA",
                                title: "DA",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "OtherAllowance",
                                title: "Other Allowance"
                            },
                            {
                                name: "TotalSalary",
                                title: "Total Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            }
                        ],
                        colCount: 3
                    },
                    {
                        type: "multipletext",
                        name: "HeadSecurityOfficer",
                        title: "Head Security Officer",
                        isRequired: true,
                        items: [
                            {
                                name: "TotalMaleHeadOfficer",
                                title: "Total Male Head Officer",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "TotalFemaleHeadOfficer",
                                title: "Total Female Head Officer",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500
                                    }
                                ]
                            },
                            {
                                name: "BasicSalary",
                                title: "Basic Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "DA",
                                title: "DA",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "OtherAllowance",
                                title: "Other Allowance",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            },
                            {
                                name: "TotalSalary",
                                title: "Total Salary",
                                validators: [
                                    {
                                        type: "numeric",
                                        minValue: 0,
                                        maxValue: 500000
                                    }
                                ]
                            }
                        ],
                        colCount: 3
                    }
                ],
                title: "Guard Details"
            },
            {
                name: "Recruitment",
                elements: [
                    {
                        type: "dropdown",
                        name: "Transfer",
                        title: "Do You Transfer Guards?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                    {
                        type: "text",
                        name: "Reason",
                        visibleIf: "{Transfer}=\"Yes\"",
                        startWithNewLine: false,
                        title: "Reason",
                        isRequired: true
                    },
                  
                    
                    {
                        type: "text",
                        name: "requiredguards",
                        title: "No Of Guards Required From Board",
                        isRequired: true,
                        validators: [
                            {
                                type: "numeric",
                                minValue: 0,
                                maxValue: 99999999999
                            }
                        ],
                        inputType: "number",
                        size: 50
                    },
                    {
                        type: "dropdown",
                        name: "PoliceVerification",
                        title: "Have You completed Police Verification of Guards?",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    },
                     
                    {
                        type: "text",
                        name: "NonVerificationReason",
                        visibleIf: "{PoliceVerification}=\"No\"",
                        startWithNewLine: false,
                        title: "Reason for No Police Verification",
                        isRequired: true
                    },
                    {
                        type: "dropdown",
                        name: "BoardsGuardsHistory",
                        title: "Have You Recruited Guards from the Security Guards Board",
                        isRequired: true,
                        choices: [
                            "Yes",
                            "No"
                        ]
                    }
                ],
                title: "Recruitment Details"
            },
            {
                name: "Documents",
                elements: [
                    {
                        type: "file",
                        name: "AgreementCopy",
                        title: "Agreement Copy with Principal Agency",
                        isRequired: true,
                        storeDataAsText: false,
                        acceptedTypes: "image/*, application/pdf",
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "PAN",
                        title: "PAN Card",
                        isRequired: true,
                        storeDataAsText: false,
                        acceptedTypes: "image/*, application/pdf",
                        maxSize: 0
                    },
                    {
                        type: "file",
                        name: "GSTRegistration",
                        title: "GST Registration Certificate",
                        isRequired: true,
                        storeDataAsText: false,
                        acceptedTypes: "image/*, application/pdf",
                        maxSize: 0
                    },{
                        type: "file",
                        name: "ConsentLetter",
                        title: "Consent Letter",
                        isRequired: true,
                        acceptedTypes: "image/*, application/pdf",
                        imageWidth: "40",
                        storeDataAsText: false,
                        maxSize: 0
                    },


                     {
                        type: "file",
                        name: "Aggrement",
                        title: "Shops & Establishment Document",
                        acceptedTypes: "image/*, application/pdf",
                        isRequired: true,
                        storeDataAsText: false,
                        imageWidth: "40",
                        maxSize: 0
                    },{
                        type: "file",
                        name: "GSTReturns",
                        // visibleIf: "{GST} notempty",
                        title: "GST Returns of Last 3 years",
                        acceptedTypes: "image/*, application/pdf",
                        isRequired: true,
                        storeDataAsText: false,
                        imageWidth: "40",
                        maxSize: 0
                    }
                ],
                title: "Documents"
            }
        ],
        showPageNumbers: true,
        showProgressBar: "top",
        storeOthersAsComment: false,
        questionTitleTemplate: "{no}. {title} {require}"
    }
}


// WEBPACK FOOTER //
// ./src/data/index.js